import { Permissions } from '@efficiently/models';

/**
 * Whether the reader can act on billing: the deployment has billing on and the reader holds `ManageBilling`. One rule
 * for the user menu's Billing entry and the renewal prompt that points at it, so the two never disagree.
 */
export function hasBillingAccess(
	permissions: readonly Permissions[] | null | undefined,
	isBillingEnabled: boolean | undefined,
): boolean {
	return Boolean(isBillingEnabled) && (permissions?.includes(Permissions.ManageBilling) ?? false);
}
